import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Set from "@babel/runtime-corejs3/core-js/set";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapValues } from "lodash";
import Vue from "vue";
export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const EDIT_UPCOMING_ACTIVITY = "EDIT_UPCOMING_ACTIVITY";
export const SET_REGISTERED_DEVICES = "SET_REGISTERED_DEVICES";
export const SET_REGISTERED_DEVICE = "SET_REGISTERED_DEVICE";
export const SET_CURRENT_DEVICE = "SET_CURRENT_DEVICE";
export const SET_FIELD_KEY = "SET_FIELD_KEY";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";
export const EDIT_NOTIFICATION = "EDIT_NOTIFICATION";
export const RESET_RELEASE_NOTES = "RESET_RELEASE_NOTES";
const mutations = {
  [SET_NOTIFICATIONS]: (state, {
    activities = null,
    followUps = null,
    releaseNotes = null
  }) => {
    if (activities) state.activities = activities;
    if (followUps) state.followUps = followUps;
    if (releaseNotes) {
      state.releaseNotes.byId = _objectSpread(_objectSpread({}, state.releaseNotes.byId), releaseNotes.byId);
      state.releaseNotes.allIds = [...new _Set([...state.releaseNotes.allIds, ...releaseNotes.allIds])];
    }
  },
  [ADD_NOTIFICATION]: (state, {
    type,
    id,
    data
  }) => {
    state[type].byId = _objectSpread(_objectSpread({}, state[type].byId), {}, {
      [id]: data
    });
    state[type].allIds = [...state[type].allIds, id];
  },
  [EDIT_NOTIFICATION]: (state, {
    type,
    id,
    data
  }) => {
    state[type].byId = _objectSpread(_objectSpread({}, state[type].byId), {}, {
      [id]: data
    });
  },
  [RESET_RELEASE_NOTES]: state => {
    state.releaseNotes = {
      byId: {},
      allIds: []
    };
  },
  [EDIT_UPCOMING_ACTIVITY]: (state, {
    id,
    complete
  }) => {
    state.followUps.byId[id] = _objectSpread(_objectSpread({}, state.followUps.byId[id]), {}, {
      complete
    });
  },
  [SET_REGISTERED_DEVICES]: (state, {
    registeredDevices
  }) => {
    state.registeredDevices = registeredDevices;
  },
  [SET_REGISTERED_DEVICE]: (state, {
    deviceId
  }) => {
    var _context;
    Vue.set(state.registeredDevices.byId, deviceId, {
      deviceId
    });
    if (!_includesInstanceProperty(_context = state.registeredDevices.allIds).call(_context, deviceId)) {
      state.registeredDevices.allIds.push(deviceId);
    }
  },
  [SET_CURRENT_DEVICE]: (state, data) => {
    state.currentDevice = _objectSpread(_objectSpread({}, state.currentDevice), data);
  },
  [SET_FIELD_KEY]: (state, {
    type,
    key,
    value
  }) => {
    const notifications = state[type];
    const byId = mapValues(notifications.byId, notification => {
      notification[key] = value;
      return notification;
    });
    Vue.set(state[type], "byId", byId);
  },
  [REMOVE_NOTIFICATION]: (state, {
    type,
    id
  }) => {
    var _context2;
    state[type].allIds = _filterInstanceProperty(_context2 = state[type].allIds).call(_context2, item => item !== id);
    delete state[type].byId[id];
  }
};
export default mutations;